// @ts-nocheck

/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "@kubb/plugin-client/clients/axios";
import type { StartDeeplinkLoginAuthLoginTelegramDeeplinkStartPostMutationResponse } from "../models/authenticationController/StartDeeplinkLoginAuthLoginTelegramDeeplinkStartPost.ts";
import type { Client, RequestConfig, ResponseErrorConfig } from "@kubb/plugin-client/clients/axios";

function getStartDeeplinkLoginAuthLoginTelegramDeeplinkStartPostUrl() {
  const res = { method: 'POST', url: `/auth/login/telegram/deeplink/start` as const }
  return res
}

/**
 * @description Start Telegram deep link login flow.
 * Returns a token and bot URL. User should be redirected to bot URL.
 * Frontend should then poll /poll endpoint.
 * @summary Start Deeplink Login
 * {@link /auth/login/telegram/deeplink/start}
 */
export async function startDeeplinkLoginAuthLoginTelegramDeeplinkStartPost(config: Partial<RequestConfig> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config



  const res = await request<StartDeeplinkLoginAuthLoginTelegramDeeplinkStartPostMutationResponse, ResponseErrorConfig<Error>, unknown>({ method : "POST", url : getStartDeeplinkLoginAuthLoginTelegramDeeplinkStartPostUrl().url.toString(), ... requestConfig })
  return res.data
}